//---Separate token storage (SRP – single responsibility).---//
let memoryToken: string | null = null;

export function getAccessToken() {
  return memoryToken;
}

export function setAccessToken(token: string | null) {
  memoryToken = token;
}
